async function casebyEmail(email, org = 'olx') {
  try {
    const res = await fetch(`/api/v1/case-by-email?email=${email}&org=${org}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          process.env.NEXT_PUBLIC_API_V1_ACCESS_TOKEN ||
          'token-not-set-in-env-variables',
      },
    });

    return res.json();
  } catch (err) {
    return null;
  }
}
export default casebyEmail;
